import { useCallback, useEffect, useRef } from 'react';

export function useTimeout(callback, delay = 0) {
  const cbRef = useRef(callback);
  const timeoutRef = useRef();

  useEffect(() => {
    cbRef.current = callback;
  }, [callback]);

  const set = useCallback(() => {
    timeoutRef.current = setTimeout(() => cbRef.current(), delay);
  }, [delay]);

  const clear = useCallback(() => {
    timeoutRef && timeoutRef.current && clearTimeout(timeoutRef.current);
  }, []);

  useEffect(() => {
    set();
    return clear;
  }, [delay, set, clear]);

  const reset = useCallback(() => {
    clear();
    set();
  }, [clear, set]);

  return { reset, clear };
}

// USAGE
// export function TimeoutComponent() {
//   const [count, setCount] = useState(10);
//   const { clear, reset } = useTimeout(() => setCount(0), 1000)

//   return (
//     <div>
//       <div>{count}</div>
//       <p>This button Increments the count</p>
//       <button onClick={() => setCount(c => c + 1)}>Increment 1</button>
//       <p>This Clears the Timeout</p>
//       <button onClick={clear}>Clear</button>
//       <p>This Resets the Timeout</p>
//       <button onClick={reset}>Reset</button>
//     </div>
//   )
// }
